import { ServiceBase } from '../../../../core/services/ServiceBase'
import Proxy from './proxy'

class Service extends ServiceBase {
  getDetailData({ path, params }) {
    return this.getData(() => Proxy.getDetailData({ path, params }))
  }

  getSummaryHighlight(params) {
    return this.getData(() => Proxy.getSummaryHighlight(params))
  }

  getMaxDate(params) {
    return this.getData(() => Proxy.getMaxDate(params))
  }
}

export default new Service()
